import PieChart1 from './PieChart1';
import {useTranslation} from 'react-i18next';
import TableTop1 from './TableTop1';
import PieChart5 from './PieChart5';
import TableTop5 from './TableTop5';
import React, {useEffect, useState} from 'react';
import {getTopClientesUmAno, getTopClientesCincoAnos} from '../../../../pages/requests';

// import { Container } from './styles';

function Top30() {
    const {t} = useTranslation();
    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const [loading, setLoading] = useState(true);
    const [clientes1, setClientes1] = useState([]);
    const [clientes5, setClientes5] = useState([]);

    useEffect(() => {
        setLoading(false);
        var promises = [];
        promises.push(
            getTopClientesUmAno(lang).then(res => {
                if (res.data.success) {
                    setClientes1(res.data.topClientesUmAno);
                }
            }),
        );

        promises.push(
            getTopClientesCincoAnos(lang).then(res => {
                if (res.data.success) {
                    setClientes5(res.data.topClientesCincoAnos);
                }
            }),
        );

        Promise.all(promises).finally(() => {
            setLoading(false);
        });
    }, []);

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2  gap-4">
            <div className="grid grid-cols-1 lg:grid-cols-3  gap-4">
                <div className="col-span-1">
                    <PieChart1 clientes={clientes1} />
                </div>
                <div className="col-span-2">
                    <TableTop1 clientes={clientes1} />
                </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3  gap-4">
                <div className="col-span-1">
                    <PieChart5 clientes={clientes5}/>
                </div>
                <div className="col-span-2">
                    <TableTop5 clientes={clientes5} />
                </div>
            </div>
        </div>
    );
}

export default Top30;
